import { atom } from 'jotai';

export const isPrefilledAtom = atom<boolean>(false);
